import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormLabelComponent } from '../form-label/form-label.component';

@Component({
    selector: 'toggle-switch',
    standalone: true,
    imports: [ToggleSwitchModule, FormsModule, FormLabelComponent],
    templateUrl: './toggle-switch.component.html',
    styleUrl: './toggle-switch.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleSwitchComponent {
    id = input.required<string>();
    value = model.required<boolean>();

    label = input<string>('');
    tooltipText = input<string>('');

    required = input<boolean>(false);
    disabled = input<boolean>(false);
}
